import type { MouseEvent} from "react";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { useLocalizedAppContext } from "src/app/hooks/useLocalizedAppContext";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import type {
  InterfaceLanguageCode} from "src/app/consts/AvailableLanguages";
import {
  AVAILABLE_LANGUAGES
} from "src/app/consts/AvailableLanguages";
import { InterfaceLanguageName } from "src/app/formatters/LanguageFormatters";

export interface ILanguageSwitchProps {}

export const LanguageSwitch = ({ ...rest }: ILanguageSwitchProps) => {
  const { locale: selectedLanguage } = useIntl();
  const { setLanguageCode } = useLocalizedAppContext();
  const handleClick = useCallback(
    (event: MouseEvent, language: InterfaceLanguageCode) => {
      event.preventDefault();
      setLanguageCode(language);
    },
    [setLanguageCode],
  );

  return (
    <UncontrolledDropdown {...rest}>
      <DropdownToggle caret={true} nav={true}>
        <InterfaceLanguageName
          languageCode={selectedLanguage as InterfaceLanguageCode}
        />
      </DropdownToggle>
      <DropdownMenu>
        {AVAILABLE_LANGUAGES.map((language) => (
          <DropdownItem
            key={language}
            onClick={(event) => handleClick(event, language)}
            active={language === selectedLanguage}
          >
            <InterfaceLanguageName languageCode={language} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
